/* JELO · Carruseles móviles v21 — circulares y a prueba de Safari/iPhone.
   Solo móvil y tableta (hasta 989px). El escritorio no se toca (lo sigue llevando jelo-home-rails-hardstop-v8.js).

   Por qué es más sólido que la v12:
   1) RESPALDO NATIVO: sin JavaScript (o hasta que se mide bien) el carrusel es una fila deslizable normal.
      El giro circular solo se activa cuando se ha medido con éxito. Nunca queda «estático».
   2) SOLO SE PINTAN LAS TARJETAS CERCANAS: unas 4-6 por carrusel en vez de 50. Menos capas = Safari no deja huecos en blanco.
   3) SE AUTORREPARA: vuelve a medir al cargar, al girar el móvil, al volver a la pestaña, al aparecer en pantalla,
      al terminar las fuentes y con la transición de páginas de Safari. Si hay pocas tarjetas, las repite para que el giro sea continuo.
   4) TODO EL ESTILO VA EN LÍNEA desde JavaScript, así no depende del orden de las hojas de estilo.
   Mantiene el nombre window.JeloHardStopV8 porque la portada lo llama así. */
(() => {
  'use strict';
  if (window.JeloHardStopV8 && window.JeloHardStopV8.version === 21) return;

  const small = window.matchMedia('(max-width:989px)');
  const reduced = window.matchMedia('(prefers-reduced-motion: reduce)');
  const registry = new WeakMap();
  const instances = new Set();
  const clamp = (value, min, max) => Math.min(max, Math.max(min, value));
  const easeOut = (t) => 1 - Math.pow(1 - t, 3);
  const pixel = (value) => {
    const ratio = window.devicePixelRatio || 1;
    return Math.round(value * ratio) / ratio;
  };

  const ITEM_PROPS = ['position', 'left', 'top', 'width', 'height', 'margin', 'flex', 'min-width', 'max-width', 'box-sizing', 'transform', 'visibility', 'scroll-snap-align'];
  const CHAIN_PROPS = ['display', 'position', 'width', 'min-width', 'max-width', 'height', 'padding', 'margin', 'gap', 'transform', 'overflow', 'flex', 'will-change'];
  const VIEW_PROPS = ['overflow', 'overflow-x', 'overflow-y', 'touch-action', 'scroll-snap-type', 'padding-left', 'padding-right', 'position', 'display', 'height', 'box-sizing', 'overscroll-behavior', '-webkit-user-select', 'user-select'];

  const put = (element, props) => {
    Object.keys(props).forEach((name) => element.style.setProperty(name, props[name], 'important'));
  };
  const drop = (element, names) => {
    names.forEach((name) => element.style.removeProperty(name));
    if (!element.getAttribute('style')) element.removeAttribute('style');
  };

  /* Fotos: todas, por tandas pequeñas y solo después de la carga de la página. */
  const queue = [];
  let pumping = false;
  let waiting = false;
  const pump = () => {
    if (pumping || !queue.length) return;
    if (document.readyState !== 'complete') {
      if (!waiting) {
        waiting = true;
        window.addEventListener('load', () => {
          waiting = false;
          window.setTimeout(pump, 600);
        }, { once: true });
      }
      return;
    }
    pumping = true;
    const step = () => {
      queue.splice(0, 6).forEach((image) => {
        if (image.loading === 'lazy') image.loading = 'eager';
      });
      if (queue.length) window.setTimeout(step, 160);
      else pumping = false;
    };
    window.setTimeout(step, 200);
  };
  const wake = (element) => {
    element.querySelectorAll('img[loading="lazy"]').forEach((image) => {
      image.loading = 'eager';
    });
  };

  const init = (viewport, options) => {
    if (!viewport || !small.matches) return null;
    const existing = registry.get(viewport);
    if (existing) {
      existing.enable();
      return existing;
    }
    const opts = options || {};
    const selector = opts.itemSelector || ':scope > *';
    const wrap = opts.wrap || viewport.closest('.jelo-home__rail-wrap');

    let enabled = true;
    let looping = false;
    let ready = false;
    let items = [];
    let clones = [];
    let chain = [];
    let shown = [];
    let woke = [];
    let unit = 0;
    let width = 0;
    let total = 0;
    let x = 0;
    let lastWidth = -1;
    let drag = null;
    let anim = null;
    let frame = 0;
    let measureFrame = 0;
    let suppressUntil = 0;
    let pending = false;

    const mod = (value) => ((value % total) + total) % total;

    const deactivate = () => {
      clones.forEach((clone) => clone.remove());
      clones = [];
      items.forEach((element) => drop(element, ITEM_PROPS));
      chain.forEach((element) => drop(element, CHAIN_PROPS));
      drop(viewport, VIEW_PROPS);
      viewport.classList.remove('jelo-rail-virtual', 'is-moving', 'is-dragging');
      items = [];
      chain = [];
      shown = [];
      woke = [];
      looping = false;
    };

    const render = () => {
      if (!looping || unit <= 0 || total <= 0) return;
      const left = -unit;
      const right = width + unit * 0.5;
      const near = unit * 2;
      for (let i = 0; i < items.length; i += 1) {
        const position = mod(i * unit - x + unit) - unit;
        const element = items[i];
        if (!woke[i] && position > -near && position < width + near) {
          woke[i] = true;
          wake(element);
        }
        if (position > left - 1 && position < right) {
          element.style.setProperty('transform', 'translate3d(' + pixel(position) + 'px,0,0)', 'important');
          if (!shown[i]) {
            shown[i] = true;
            element.style.setProperty('visibility', 'visible', 'important');
          }
        } else if (shown[i]) {
          shown[i] = false;
          element.style.setProperty('visibility', 'hidden', 'important');
          element.style.removeProperty('transform');
        }
      }
    };

    const stopAnim = () => {
      if (frame) window.cancelAnimationFrame(frame);
      frame = 0;
      anim = null;
    };

    const measure = () => {
      if (!enabled || !viewport.isConnected || !small.matches) return;
      if (drag || anim) {
        pending = true;
        return;
      }
      pending = false;
      const fraction = unit ? x / unit : 0;
      deactivate();
      viewport.scrollLeft = 0;
      const viewWidth = viewport.clientWidth;
      lastWidth = viewWidth;
      if (viewWidth < 40) {
        ready = false;
        return;
      }
      const real = Array.from(viewport.querySelectorAll(selector)).filter((element) => !element.closest('[data-jelo-clone]'));
      if (real.length < 2) {
        ready = true;
        if (wrap) wrap.classList.add('is-static');
        return;
      }
      const first = real[0];
      const rectA = first.getBoundingClientRect();
      const rectB = real[1].getBoundingClientRect();
      const host = first.parentElement;
      const cardWidth = rectA.width;
      let step = rectB.left - rectA.left;
      if (!(step > 1)) {
        const gap = parseFloat(window.getComputedStyle(host).columnGap) || 0;
        step = cardWidth + gap;
      }
      let cardHeight = 0;
      real.forEach((element) => {
        cardHeight = Math.max(cardHeight, Math.ceil(element.getBoundingClientRect().height));
      });
      if (!(cardWidth > 20) || !(step > 20) || !(cardHeight > 20)) {
        ready = false;
        return;
      }
      ready = true;
      const content = real.length * step - (step - cardWidth);
      if (content <= viewWidth + 1) {
        if (wrap) wrap.classList.add('is-static');
        return;
      }
      if (wrap) wrap.classList.remove('is-static');

      /* Si hay pocas tarjetas, se repiten para que el giro sea continuo y sin huecos. */
      unit = step;
      width = viewWidth;
      const reps = clamp(Math.ceil((width + unit * 2 + 2) / (real.length * unit)), 1, 12);
      items = real.slice();
      for (let r = 1; r < reps; r += 1) {
        real.forEach((element) => {
          const clone = element.cloneNode(true);
          clone.setAttribute('data-jelo-clone', 'true');
          clone.setAttribute('aria-hidden', 'true');
          clone.querySelectorAll('a,button').forEach((control) => control.setAttribute('tabindex', '-1'));
          host.appendChild(clone);
          clones.push(clone);
          items.push(clone);
        });
      }
      total = items.length * unit;

      const style = window.getComputedStyle(viewport);
      const padTop = parseFloat(style.paddingTop) || 0;
      const padBottom = parseFloat(style.paddingBottom) || 0;
      chain = [];
      for (let node = host; node && node !== viewport; node = node.parentElement) chain.push(node);

      put(viewport, {
        'box-sizing': 'border-box',
        position: 'relative',
        overflow: 'hidden',
        'touch-action': 'pan-y',
        'scroll-snap-type': 'none',
        'padding-left': '0',
        'padding-right': '0',
        'overscroll-behavior': 'none',
        '-webkit-user-select': 'none',
        'user-select': 'none'
      });
      if (host === viewport) {
        put(viewport, { display: 'block', height: Math.ceil(cardHeight + padTop + padBottom) + 'px' });
      } else {
        chain.forEach((node) => {
          put(node, { display: 'block', position: 'relative', width: '100%', 'min-width': '0', 'max-width': 'none', padding: '0', margin: '0', gap: '0', transform: 'none', 'will-change': 'auto', overflow: 'visible' });
        });
        put(host, { height: cardHeight + 'px', flex: 'none' });
      }
      items.forEach((element) => {
        put(element, {
          position: 'absolute',
          left: '0',
          top: '0',
          width: cardWidth + 'px',
          height: cardHeight + 'px',
          margin: '0',
          flex: 'none',
          'min-width': '0',
          'max-width': 'none',
          'box-sizing': 'border-box',
          'scroll-snap-align': 'none',
          visibility: 'hidden'
        });
      });
      shown = new Array(items.length).fill(false);
      woke = new Array(items.length).fill(false);
      viewport.scrollLeft = 0;
      viewport.classList.add('jelo-rail-virtual', 'is-moving');
      looping = true;
      x = mod(fraction * unit);
      render();
    };

    const schedule = () => {
      if (measureFrame || !enabled) return;
      measureFrame = window.requestAnimationFrame(() => {
        measureFrame = 0;
        measure();
      });
    };

    const settle = () => {
      if (looping) x = mod(x);
      render();
      if (pending) schedule();
    };

    const tick = (now) => {
      frame = 0;
      if (!anim) return;
      const progress = clamp((now - anim.start) / anim.duration, 0, 1);
      x = anim.from + (anim.to - anim.from) * easeOut(progress);
      render();
      if (progress < 1) {
        frame = window.requestAnimationFrame(tick);
        return;
      }
      anim = null;
      settle();
    };

    const animateTo = (target, duration) => {
      stopAnim();
      if (reduced.matches || duration <= 0 || Math.abs(target - x) < 0.5) {
        x = target;
        settle();
        return;
      }
      anim = { from: x, to: target, start: performance.now(), duration };
      frame = window.requestAnimationFrame(tick);
    };

    const move = (direction) => {
      if (!enabled || !looping) return;
      const base = anim ? anim.to : x;
      const perPage = Math.max(1, Math.floor(width / unit));
      animateTo(base + direction * perPage * unit, 450);
    };

    viewport.addEventListener('pointerdown', (event) => {
      if (!enabled || !looping || !event.isPrimary) return;
      if (event.pointerType === 'mouse' && event.button !== 0) return;
      if (anim) suppressUntil = Date.now() + 400;
      stopAnim();
      drag = { id: event.pointerId, startX: event.clientX, startY: event.clientY, x0: x, axis: null, samples: [{ t: event.timeStamp, x: event.clientX }] };
    });

    viewport.addEventListener('pointermove', (event) => {
      if (!drag || event.pointerId !== drag.id) return;
      if (!drag.axis) {
        const dx = event.clientX - drag.startX;
        const dy = event.clientY - drag.startY;
        if (Math.max(Math.abs(dx), Math.abs(dy)) < 6) return;
        if (Math.abs(dx) <= Math.abs(dy)) {
          drag = null;
          return;
        }
        drag.axis = 'x';
        drag.startX = event.clientX;
        drag.x0 = x;
        drag.samples = [{ t: event.timeStamp, x: event.clientX }];
        viewport.classList.add('is-dragging');
        try {
          viewport.setPointerCapture(event.pointerId);
        } catch (error) {
          /* sin captura */
        }
        return;
      }
      x = drag.x0 - (event.clientX - drag.startX);
      render();
      drag.samples.push({ t: event.timeStamp, x: event.clientX });
      if (drag.samples.length > 8) drag.samples.shift();
    });

    const finish = (event) => {
      if (!drag || event.pointerId !== drag.id) return;
      const current = drag;
      drag = null;
      viewport.classList.remove('is-dragging');
      try {
        viewport.releasePointerCapture(event.pointerId);
      } catch (error) {
        /* ya liberado */
      }
      if (current.axis === 'x') {
        suppressUntil = Date.now() + 350;
        const samples = current.samples;
        const last = samples[samples.length - 1];
        let velocity = 0;
        if (event.type === 'pointerup' && event.timeStamp - last.t < 80) {
          const firstSample = samples.find((sample) => last.t - sample.t <= 100) || samples[0];
          velocity = (firstSample.x - last.x) / Math.max(1, last.t - firstSample.t);
        }
        const projection = clamp(velocity * 260, -width * 1.2, width * 1.2);
        const target = Math.round((x + projection) / unit) * unit;
        animateTo(target, clamp(360 + Math.abs(target - x) * 0.5, 360, 900));
      } else if (pending) {
        schedule();
      }
    };
    viewport.addEventListener('pointerup', finish);
    viewport.addEventListener('pointercancel', finish);

    viewport.addEventListener('click', (event) => {
      if (Date.now() >= suppressUntil) return;
      event.preventDefault();
      event.stopPropagation();
    }, true);
    viewport.addEventListener('dragstart', (event) => event.preventDefault());
    viewport.addEventListener('scroll', () => {
      if (looping && viewport.scrollLeft !== 0) viewport.scrollLeft = 0;
    }, { passive: true });
    if (opts.keyboard) {
      viewport.addEventListener('keydown', (event) => {
        if (event.target !== viewport || (event.key !== 'ArrowLeft' && event.key !== 'ArrowRight')) return;
        event.preventDefault();
        move(event.key === 'ArrowRight' ? 1 : -1);
      });
    }

    if ('ResizeObserver' in window) {
      new ResizeObserver(() => {
        if (Math.abs(viewport.clientWidth - lastWidth) >= 1) schedule();
      }).observe(viewport);
    }
    if ('IntersectionObserver' in window) {
      new IntersectionObserver((entries) => {
        if (entries.some((entry) => entry.isIntersecting) && (!ready || Math.abs(viewport.clientWidth - lastWidth) >= 1)) schedule();
      }, { rootMargin: '300px 0px' }).observe(viewport);
    }

    const api = {
      move,
      pause() {},
      refresh: schedule,
      enable() {
        if (enabled) return;
        enabled = true;
        viewport.classList.add('jelo-rail');
        schedule();
      },
      disable() {
        enabled = false;
        stopAnim();
        drag = null;
        deactivate();
        viewport.classList.remove('jelo-rail');
        if (wrap) wrap.classList.remove('is-static');
      }
    };

    viewport.classList.add('jelo-rail');
    registry.set(viewport, api);
    instances.add(api);
    viewport.querySelectorAll('img[loading="lazy"]').forEach((image) => queue.push(image));
    pump();
    measure();
    return api;
  };

  window.JeloHardStopV8 = { init, version: 21 };

  const groups = [
    ['.jelo-home__marquee', '.jelo-home__marquee-item'],
    ['.jelo-home__collection-rail', '.jelo-home__collection-card'],
    ['.jelo-footer-products__scroll', '.jelo-footer-products__item']
  ];
  const autoInit = () => {
    if (!small.matches) return;
    groups.forEach((group) => {
      document.querySelectorAll(group[0]).forEach((element) => init(element, { itemSelector: group[1], keyboard: true }));
    });
  };
  const refreshAll = () => {
    if (!small.matches) return;
    autoInit();
    instances.forEach((instance) => instance.refresh());
  };
  const onChange = () => {
    if (small.matches) {
      instances.forEach((instance) => instance.enable());
      refreshAll();
    } else {
      instances.forEach((instance) => instance.disable());
    }
  };
  if (small.addEventListener) small.addEventListener('change', onChange);
  else if (small.addListener) small.addListener(onChange);

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', autoInit, { once: true });
  else autoInit();

  /* Red de seguridad para Safari: vuelve a medir en cada momento en que el tamaño real puede haber cambiado. */
  window.addEventListener('load', refreshAll, { once: true });
  window.addEventListener('pageshow', refreshAll);
  window.addEventListener('pagereveal', () => window.setTimeout(refreshAll, 60));
  window.addEventListener('orientationchange', () => window.setTimeout(refreshAll, 250));
  document.addEventListener('visibilitychange', () => {
    if (document.visibilityState === 'visible') refreshAll();
  });
  document.addEventListener('shopify:section:load', refreshAll);
  if (document.fonts && document.fonts.ready) document.fonts.ready.then(refreshAll);
  [350, 1400, 4000].forEach((delay) => window.setTimeout(refreshAll, delay));
})();
